import { Component } from "react";
import ReactDOM from "react-dom";
import "@okta/okta-signin-widget/dist/css/okta-sign-in.min.css";
import "@okta/okta-signin-widget/dist/css/okta-theme.css";
import "./OktaSignInWidget.css";
import loadConfig from "../../Config";

export default class OktaSignInWidget extends Component {
  async componentDidMount() {
    // eslint-disable-next-line react/no-find-dom-node
    const el = ReactDOM.findDOMNode(this);
    const envConfig = await loadConfig();
    const baseURL = envConfig.passwordUrl;

    // Loading this way code splits into a separate chunk instead
    // of including in the main chunk, helpful when loading unauth
    // pages whereby signin resources are not needed
    const oktaSignInWidget = await import("@okta/okta-signin-widget");
    const OktaSignIn = oktaSignInWidget.default;

    this.widget = new OktaSignIn({
      // eslint-disable-next-line react/destructuring-assignment
      baseUrl: this.props.baseUrl,
      logo: "../static/media/logo-menu.97ef1f90.svg",
      helpLinks: {
        help: "https://pub.dash.sensis.com.au/activate-my-account",
        forgotPassword: `${baseURL}/myaccount/#/forgot-password`,
      },
      i18n: {
        en: {
          help: "Register for myYellow",
        },
      },
    });

    // OktaSignInWidget.js (inside componentDidMount, before renderEl)
    this.widget.on("afterRender", () => {
      const head = document.querySelector("#okta-sign-in .o-form-head");
      if (!head) return;

      // Avoid duplicates across re-renders
      if (!head.querySelector(".maintenance-msg")) {
        const p = document.createElement("p");
        p.className = "maintenance-msg";
        p.setAttribute("role", "status"); // accessibility
        p.setAttribute("aria-live", "polite"); // accessibility

        // Text Message before link
        const message = document.createTextNode(
          "We’ve moved reporting to a new location. You can now access your reports by visiting "
        );

        // Create the link and set its properties
        const link = document.createElement("a");
        link.href = "https://leads.thryv.com/";
        link.textContent = "https://leads.thryv.com/";
        link.style.color = "blue";
        link.style.textDecoration = "underline";

        p.appendChild(message);
        p.appendChild(link);

        // 👉 Insert as the FIRST child so it appears:
        // ::before (grey note) → [THIS MESSAGE] → "Sign In" title → form
        if (head.firstChild) {
          head.insertBefore(p, head.firstChild);
        } else {
          head.appendChild(p);
        }
      }

      // Disable all input fields
      const inputFields = document.querySelectorAll("input");
      Array.from(inputFields).forEach((ele) => {
        Object.assign(ele, { disabled: true });
      });

      // Disable the click event for help
      const helpLink = document.querySelector(".help.js-help");
      if (helpLink && helpLink.tagName === "A") {
        const span = document.createElement("span");
        span.textContent = helpLink.textContent;
        span.className = helpLink.className.replace("js-help", ""); // strip js-help

        helpLink.parentNode.replaceChild(span, helpLink);
      }
    });

    // eslint-disable-next-line react/destructuring-assignment
    this.widget.renderEl({ el }, this.props.onSuccess, this.props.onError);
    // Disable the button after widget renders
    const interval = setInterval(() => {
      const btn = document.getElementById("okta-signin-submit");
      if (btn) {
        btn.disabled = true; // Disable the button
        btn.style.opacity = "0.5"; // Optional styling
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }

  componentWillUnmount() {
    // eslint-disable-next-line no-unused-expressions
    this.widget && this.widget.remove();
  }

  render() {
    return <div />;
  }
}
